import { render, staticRenderFns } from "./AppPassword.vue?vue&type=template&id=3c5998a0&scoped=true"
import script from "./AppPassword.vue?vue&type=script&lang=js"
export * from "./AppPassword.vue?vue&type=script&lang=js"
import style0 from "./AppPassword.vue?vue&type=style&index=0&id=3c5998a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5998a0",
  null
  
)

export default component.exports